import type { AppLoadingProps } from "./app-loading.type";

import { Spin, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

export const AppLoading = ({
  title,
  display = true,
  ...spinProps
}: AppLoadingProps) => {
  const { t } = useTranslation();

  if (!display) {
    return null;
  }

  if (title) {
    return (
      <Tooltip title={title}>
        <Spin aria-label={t("global:loading")} {...spinProps} />
      </Tooltip>
    );
  }

  return <Spin aria-label={t("global:loading")} {...spinProps} />;
};
